import styled from 'styled-components';

export const DeleteBtn = styled.div`
  ${({ theme: { color: { pink } } }) => ({ color: pink })};
`;
